<div *ngIf="loading"
     class="loading-overlay">
  <i class="fa fa-2x fa-spinner fa-spin text-secondary"></i>
  <h3 class="mt-3 ml-1 text-secondary">Cargando...</h3>
</div>

<div *ngIf="modalPedidoOrigenSrv.loading"
     class="loading-overlay">
  <i class="fa fa-2x fa-spinner fa-spin text-secondary"></i>
  <h3 class="mt-3 ml-1 text-secondary">Cargando pedido origen...</h3>
</div>


<div *ngIf="loadingAlbaran"
     class="loading-overlay">
  <i class="fa fa-2x fa-spinner fa-spin text-secondary"></i>
  <h3 class="mt-3 ml-1 text-secondary">Generando albarán...</h3>
</div>




<div class="row animated fadeIn fast">

  <div class="col-12">
    <div class="card border rounded animated fadeIn fast">
      <div class="card-body animated fadeIn fast">


        <!-- cabecera  -->
        <div class="row mb-2">

          <div class="col-2">
            <div class="input-group border border-dark rounded">
              <input class="form-control"
                     type="text"
                     id="buscaTodo"
                     autofocus
                     placeholder="Buscar cualquier dato..."
                     [(ngModel)]="strBuscarTodo"
                     (keyup)="buscarTodo()" />
              <div class="input-group-append">
                <button class="btn btn-outline-secondary"
                        type="button"
                        title="Limpiar búsqueda"
                        (click)="limpiaBusca()">
                  <i class="fas fa-times"></i>
                </button>
              </div>
            </div>
          </div>



          <!-- pedidosSearch -->
          <div class="col-2">
            <div class="input-group border border-dark rounded">
              <input class="form-control"
                     type="text"
                     id="buscaPedido"
                     placeholder="Buscar pedido.."
                     [(ngModel)]="pedidosSearch"
                     (keydown.enter)="buscarPedido($event)" />
              <div class="input-group-append">
                <button class="btn btn-outline-secondary"
                        type="button"
                        title="Limpiar búsqueda"
                        (click)="limpiaBuscaPedido()">
                  <i class="fas fa-times"></i>
                </button>
              </div>
            </div>
          </div>



          <!-- cliSeleccionado -->
          <div class="col-2">
            <div class="input-group border border-dark rounded">
              <div class="input-group-addon"
                   title="Cliente"
                   style="cursor: default"><i class="fa-solid fa-user"></i></div>
              <select class="form-control"
                      [(ngModel)]="cliSeleccionado"
                      (ngModelChange)="onClienteSelect($event)">
                <option value=''>Todos los clientes</option>
                <option *ngFor="let cli of clientesList"
                        [value]=cli.id>
                  {{cli.nombre}}
                </option>
              </select>
            </div>
          </div>

          <!-- estadoSeleccionado -->
          <div class="col-2">
            <div class="input-group border border-dark rounded">
              <div class="input-group-addon"
                   title="Estado de la Recogida"
                   style="cursor: default">R</div>
              <select class="form-control"
                      [(ngModel)]="estadoSeleccionado"
                      (ngModelChange)="onEstadoSelect($event)">
                <option value=''>Todos los estados</option>
                <option *ngFor="let estado of estadosList"
                        [value]=estado.id>
                  {{estado.nombre}}
                </option>
              </select>
            </div>
          </div>


          <!-- estadoPreparacionSeleccionado -->
          <div class="col-2">
            <div class="input-group border border-dark rounded">
              <div class="input-group-addon"
                   title="Estado de la Preparación"
                   style="cursor: default">P</div>
              <select class="form-control"
                      [(ngModel)]="estadoPreparacionSeleccionado"
                      (ngModelChange)="onEstadoPreparacionSelect($event)">
                <option value=''>Todos los estados</option>
                <option *ngFor="let estado of estadosPreparacionList"
                        [value]=estado.id>
                  {{estado.nombre}}
                </option>
              </select>
            </div>
          </div>


          <div class="col-2">
            <form>

              <div class="row float-right">

                <div class="col-sm-6">
                  <div class="form-group rounded">
                    <select class="form-control"
                            name="rowsLimitStr"
                            [(ngModel)]="rowsLimitStr"
                            (change)="rowsLimitChange()">
                      <option [value]="10">10</option>
                      <option [value]="50">50</option>
                      <option [value]="100">100</option>
                      <option [value]="999999">Todo</option>
                    </select>
                  </div>
                </div>

                <div class="col-sm-6">
                  <div class="form-group float-right">
                    <div class="btn-group">

                      <button *ngIf="gurdaVistaFlag"
                              type="button"
                              (click)="guardaOpcionesList()"
                              class="btn btn-outline btn-circle bg-success text-white"
                              title="Limpiar opciones de la vista guardadas">
                        <i class="fa-solid fa-thumbtack"></i>
                      </button>
                      <button *ngIf="!gurdaVistaFlag"
                              type="button"
                              (click)="guardaOpcionesList()"
                              class="btn btn-outline-info btn-circle"
                              title="Guardar opciones de la vista">
                        <i class="fa-solid fa-thumbtack"></i>
                      </button>

                      <a type="button"
                         [routerLink]="'/panel/campanya_new'"
                         class="btn btn-outline-info btn-circle "
                         title="Nuevo">
                        <i class="fa-solid fa-plus"></i>
                      </a>

                      <button type="button"
                              (click)="exportToExcel()"
                              class="btn btn-outline-info btn-circle"
                              title="Descargar Excel">
                        <i class="fa-solid fa-download"></i>
                      </button>

                    </div>
                  </div>
                </div>

              </div>

            </form>
          </div>

        </div>


        <div class="rounded border ngx-table-container">

          <!-- datatable -->
          <ngx-datatable class="bootstrap"
                         [style.width]="'100%'"
                         [limit]="rowsLimit"
                         [rows]="rows"
                         [columnMode]="ColumnMode.force"
                         [headerHeight]="50"
                         [footerHeight]="50"
                         [messages]="messages"
                         rowHeight="auto"
                         [summaryRow]="true"
                         [summaryHeight]="50"
                         [summaryPosition]="summaryPosition"
                         [rowClass]="getRowClass">



            <!-- camp_cod -->
            <ngx-datatable-column name="Código"
                                  prop='camp_cod'
                                  [width]="150"
                                  [maxWidth]="150"
                                  [resizeable]="false"
                                  [summaryFunc]="literalTotal">

              <ng-template let-value="value"
                           let-row="row"
                           ngx-datatable-cell-template>
                <div class="d-flex align-items-center">
                  <span class="monospace"
                        [ngClass]="{'text-warning': row.campanyaTipo === '1 a 1'}"
                        [class.text-primary]="row.destacarLinea"
                        [innerHTML]="funcLib.resaltarTexto(value, textoDestacado)"></span>
                  <img *ngIf=" row.campanyaTipo === '1 a 1'"
                       src="../../../assets/images/icon/1a1.png"
                       height="20px"
                       alt="1 a 1"
                       class="d-inline-block ml-2">
                </div>
              </ng-template>
            </ngx-datatable-column>


            <!-- created_at -->
            <ngx-datatable-column name="Fecha"
                                  prop='created_at'
                                  [width]="180"
                                  [maxWidth]="180"
                                  [resizeable]="false">
              <ng-template let-value="value"
                           ngx-datatable-cell-template>
                <div class="monospace"
                     [innerHTML]="funcLib.resaltarTexto(value, textoDestacado)">
                </div>
              </ng-template>
            </ngx-datatable-column>


            <!-- cliNombre -->
            <ngx-datatable-column name="Cliente"
                                  prop='cliNombre'
                                  [width]="180"
                                  [maxWidth]="200"
                                  [flexGrow]="1"
                                  [resizeable]="false">
              <ng-template let-value="value"
                           let-row="row"
                           ngx-datatable-cell-template>
                <span [innerHTML]="funcLib.resaltarTexto(value, textoDestacado)"></span>
              </ng-template>
            </ngx-datatable-column>


            <!-- estado -->
            <ngx-datatable-column name="Recogida"
                                  prop='estado'
                                  [width]="140"
                                  [maxWidth]="140"
                                  [resizeable]="false">
              <ng-template let-value="value"
                           ngx-datatable-cell-template>
                <div [innerHTML]="value | campanyaEstado"></div>
              </ng-template>
            </ngx-datatable-column>

            <!-- estado_preparacion -->
            <ngx-datatable-column name="Preparación"
                                  prop='estado_preparacion'
                                  [width]="130"
                                  [maxWidth]="130"
                                  [resizeable]="false">
              <ng-template let-value="value"
                           ngx-datatable-cell-template>
                <div [innerHTML]="value | campanyaEstadoPreparacion"></div>
              </ng-template>
            </ngx-datatable-column>


            <!-- tot_pedidos -->
            <ngx-datatable-column name="Pedidos"
                                  prop='tot_pedidos'
                                  class="text-right"
                                  title="Número de pedidos para esta campaña"
                                  [cellClass]="'text-right'"
                                  [maxWidth]="85"
                                  [summaryFunc]="sumaCeldas">
              <ng-template let-value="value"
                           ngx-datatable-cell-template>
                <div [innerHTML]="funcLib.resaltarTexto(value | number: '0.0-0':'es', textoDestacado)"></div>
              </ng-template>
            </ngx-datatable-column>


            <!-- tot_articulos -->
            <ngx-datatable-column name="Articulos"
                                  prop='tot_articulos'
                                  class="text-right"
                                  title="Suma de artículos en todos los pedidos"
                                  [cellClass]="'text-right'"
                                  [maxWidth]="85"
                                  [summaryFunc]="sumaCeldas">
              <ng-template let-value="value"
                           ngx-datatable-cell-template>
                <div [innerHTML]="funcLib.resaltarTexto(value | number: '0.0-0':'es', textoDestacado)"></div>
              </ng-template>
            </ngx-datatable-column>


            <!-- tot_referencias -->
            <ngx-datatable-column prop='tot_referencias'
                                  name="Refs."
                                  class="text-right"
                                  title='Número de referencias únicas en todos los pedidos'
                                  [cellClass]="'text-right'"
                                  [maxWidth]="85"
                                  [summaryFunc]="sumaCeldas">
              <ng-template let-value="value"
                           ngx-datatable-cell-template>
                <div [innerHTML]="funcLib.resaltarTexto(value | number: '0.0-0':'es', textoDestacado)"></div>
              </ng-template>
            </ngx-datatable-column>


            <!-- descripcion -->
            <ngx-datatable-column name="Descripción"
                                  prop='descripcion'
                                  [width]="240"
                                  [maxWidth]="460"
                                  [flexGrow]="1">
              <ng-template let-value="value"
                           ngx-datatable-cell-template>
                <div [innerHTML]="funcLib.resaltarTexto(value, textoDestacado)"></div>
              </ng-template>
            </ngx-datatable-column>



            <!-- Acciones Menú -->
            <ngx-datatable-column [width]="40"
                                  [sortable]="false"
                                  [resizeable]="false">
              <ng-template let-row="row"
                           let-rowIndex="rowIndex"
                           let-value="value"
                           ngx-datatable-cell-template>

                <div ngbDropdown
                     class="d-inline-block "
                     container="body"
                     placement="top-right">


                  <a (click)="infoClickCampanya(row)"
                     class="link mr-1 pointer"
                     title="INFORMACIÓN de esta campaña">
                    <span class="acciones-badge"
                          [ngClass]="{'infoSelect': row.id == campSel.id}">
                      I
                    </span>
                  </a>


                  <button class="btn btn-sm btn-outline-secondary dropdown-toggle"
                          data-toggle="dropdown"
                          type="button"
                          style="border-width: 1px;">
                    <i class="fa-solid fa-ellipsis-vertical"></i>
                  </button>

                  <div class="dropdown-menu dropdown-menu-center">

                    <a [routerLink]="['/panel/preparacion_new', row.id]"
                       class="link mr-2 dropdown-item"
                       title="Ver recogidas de esta campaña">
                      <i class="fa-solid fa-cart-flatbed"></i> Recogidas
                    </a>

                    <a [routerLink]="['/panel/asignar_pedidos',row.id]"
                       class="link mr-2 dropdown-item"
                       title="Ver/Asignar preparaciones de esta campaña">
                      <i class="fa-solid fa-box-open"></i> Preparaciones
                    </a>



                    <div class="dropdown-divider"></div>



                    <a (click)="['1', '2', '3'].includes(row.estado) && row.estado_preparacion == Constantes.ESTADO_CAMPANYA_PREPARACION_PENDIENTE ? editUbicaciones(row) : null"
                       class="link mr-2 dropdown-item"
                       title="Editar ubicaciones de recogida"
                       [ngClass]="{'disabled': !(['1', '2', '3'].includes(row.estado) && row.estado_preparacion == Constantes.ESTADO_CAMPANYA_PREPARACION_PENDIENTE )}">
                      <i class="fa-solid fa-map-pin"></i> Editar ubicaciones
                    </a>

                    <a (click)=" ['1', '2'].includes(row.estado_preparacion) ? campanyaAvisarCliente(row) : null"
                       class="link mr-2 dropdown-item"
                       title="AVISAR al cliente sobre los pedidos pendientes de esta campaña"
                       [ngClass]="{'disabled': ['1', '2'].includes(row.estado_preparacion) === false}">
                      <i class="fa-solid fa-bell"></i> Notificar al cliente
                    </a>

                    <a (click)="['1', '2', '3'].includes(row.estado) && row.estado_preparacion == Constantes.ESTADO_CAMPANYA_PREPARACION_PENDIENTE ? deleteRow(row) : null"
                       class="link mr-2 dropdown-item text-danger"
                       title="BORRAR esta campaña"
                       [ngClass]="{'disabled': !(['1', '2', '3'].includes(row.estado) && row.estado_preparacion == Constantes.ESTADO_CAMPANYA_PREPARACION_PENDIENTE )}">
                      <i class="fa-regular fa-trash-can fa"></i> Borrar campaña
                    </a>

                  </div>
                </div>

              </ng-template>
            </ngx-datatable-column>




          </ngx-datatable>
        </div>

      </div>
    </div>
  </div>



  <!-- Tabla de detalle de la campaña seleccionada
     Mostrar si existe lista de pedidos ó se está busando algo en la lista -->
  <div *ngIf="pedidosList.length || this.strBuscarTodoPedidos.length"
       class="col-12"
       style="min-height: 430px;">
    <div class="card">
      <div class="card-body">
        <h5>Detalle de la campaña </h5>
        <div class="row">

          <div class="col-4 ">
            <div class="border border-dark rounded p-2">
              <h4 class="card-title">Campaña <span class="text-success">{{campSel.descripcion}}</span>
              </h4>
              <h5 class="text-info">{{campSel.camp_cod}} - {{campSel.cliNombre}}
                <span *ngIf="campSel.campanyaTipo==='1 a 1'"
                      class="text-warning"><i>Campaña tipo pedido 1 a 1</i>
                </span>
              </h5>
            </div>
          </div>

          <div class="col-4">
            <div class="input-group border border-dark rounded">
              <input class="form-control"
                     type="text"
                     id="buscaTodoPedidos"
                     placeholder="Buscar cualquier dato..."
                     autocomplete='off'
                     [(ngModel)]="strBuscarTodoPedidos"
                     (keyup)="buscarTodoPedidos()" />
              <div class="input-group-append">
                <button class="btn btn-outline-secondary"
                        type="button"
                        title="Limpiar búsqueda"
                        (click)="limpiaBuscaPedidos()">
                  <i class="fas fa-times"></i>
                </button>
              </div>
            </div>


          </div>

          <div class="col-4">
            <div class="input-group border border-dark rounded  ">
              <div class="input-group-addon"
                   title="EAN"
                   style="cursor: default"><i class="fa fa-barcode"></i></div>
              <select class="form-control w-25"
                      [(ngModel)]="eanSeleccionado"
                      (ngModelChange)="onEanSelect($event)">
                <option value="">Todos los artículos</option>
                <option *ngFor="let ean of eanArray"
                        [value]=ean>
                  {{ean}}
                </option>
              </select>
            </div>
            <span class="mt-2 ml-4"
                  *ngIf="sumaCantidadesEan">{{sumaCantidadesEan | number:'0.0-0'}} Unidades
            </span>
          </div>

        </div>

        <div class="bootstrap-table mt-1">

          <div class="table-responsive">
            <table class="table table-striped table-bordered table-hover">

              <thead>
                <tr>
                  <th *ngFor="let col of colPedidosLabel"
                      (click)="ordenarPedidosCol(col.key)"
                      style="cursor: pointer"
                      [title]="col.title">
                    {{ col.label }}
                    <span *ngIf="sortColumnPed === col.key">
                      <i class="text-success"
                         [ngClass]="sortDirectionPed === 'asc' ? 'fa fa-arrow-up' : 'fa fa-arrow-down'">
                      </i>
                    </span>
                  </th>
                  <th> </th>
                  <th>Estado</th>
                  <th>Acciones</th>
                </tr>
              </thead>

              <!-- Si hay detall y no está ubicado, mostrarlo -->
              <tbody>
                <ng-container *ngFor="let pedido of pedidosList; let i = index">
                  <tr [ngClass]="{ 'infoSelectRow': pedido.id == pedidoDetall.id }">

                    <td class="align-middle"
                        style="text-align: right; padding-left: 10px">
                      <span [innerHTML]="resaltarTextoPedidos(pedido.id?.toString() || '', textoDestacadoPedidos)"></span>
                    </td>
                    <td class="align-middle">
                      <span [innerHTML]="resaltarTextoPedidos(pedido.pedido_cli?.toString() || '', textoDestacadoPedidos)"></span>
                      <span *ngIf="pedido.swDefectuoso == Constantes.DEFECTUOSO">
                        <i title="Defectuoso"
                           class="text-warning ml-1 fa-solid fa-triangle-exclamation"></i>
                      </span>
                    </td>
                    <td class="align-middle">
                      <span [innerHTML]="resaltarTextoPedidos(pedido.tipoPedido?.toString() || '', textoDestacadoPedidos)"></span>
                    </td>
                    <td class="align-middle"
                        style="text-align: right; padding-left: 10px">
                      <span [innerHTML]="resaltarTextoPedidos(pedido.cajetin?.toString() || '', textoDestacadoPedidos)"></span>
                    </td>
                    <td class="align-middle">
                      <span [innerHTML]="resaltarTextoPedidos(pedido.albaran?.toString() || '', textoDestacadoPedidos)"></span>
                    </td>
                    <td class="align-middle"
                        style="text-align: right; padding-left: 10px">
                      <div class="pl-25 mr-20 monospace"
                           [ngClass]="{'text-white bg-danger bg-opacity-10 px-2 rounded': pedido.tot_articulos! < 1}">
                        {{ pedido.tot_articulos | number: '0.0-0':'es' }}
                      </div>
                    </td>
                    <td class="align-middle"
                        style="text-align: right; padding-left: 10px">
                      <div class="pl-25 mr-20 monospace">
                        {{ pedido.tot_referencias | number: '0.0-0':'es'}}
                      </div>
                    </td>
                    <td class="align-middle"
                        title={{pedido.provincia}}>
                      <span [innerHTML]="resaltarTextoPedidos(pedido.cp?.toString() || '', textoDestacadoPedidos)"></span>
                      -
                      <span [innerHTML]="resaltarTextoPedidos(pedido.poblacion?.toString() || '', textoDestacadoPedidos)"></span>
                    </td>
                    <td class="align-middle">
                      <span [innerHTML]="resaltarTextoPedidos(pedido.pais_iso?.toString() || '', textoDestacadoPedidos)"></span>
                    </td>
                    <td class="align-middle"
                        title={{pedido.servicio?.nombre}}
                        [ngClass]="{ 'highlight-inte': pedido.cod_servicio === 'inte' }">
                      <span [innerHTML]="resaltarTextoPedidos(pedido.cod_servicio?.toString() || '', textoDestacadoPedidos)"></span>
                    </td>
                    <td class="align-middle">
                      <span [innerHTML]="resaltarTextoPedidos(pedido.nombre?.toString() || '', textoDestacadoPedidos)"></span>
                    </td>
                    <td class="align-middle">
                      <span *ngIf="pedido.aviso_cliente==='1'"
                            title="Cliente avisado, puede solicitar acciones especiales mientras esté en estado 'Pendiente'">
                        <i class="fa-regular fa-bell"></i>
                      </span>
                    </td>
                    <td class="align-middle">
                      <div [innerHTML]=" pedido.estado | pedidoEstado "
                           title={{pedido.estado_at}}></div>
                    </td>


                    <!-- acciones -->
                    <td class="align-middle">
                      <a (click)="infoClickPedido(pedido.id!)"
                         class="link mr-1 pointer"
                         title="INFORMACIÓN del pedido">
                        <span class="acciones-badge"
                              [ngClass]="{'infoSelect': pedido.id == pedidoDetall.id}">
                          I
                        </span>
                      </a>

                      <button class="btn btn-sm btn-outline-secondary dropdown-toggle"
                              data-toggle="dropdown"
                              data-boundary="window"
                              type="button"
                              style="border-width: 1px;">
                        <i class="fa-solid fa-ellipsis-vertical"></i>
                      </button>

                      <div class="dropdown-menu">

                        <!-- Opciones de ALBARÁN -->
                        <div class="dropdown-submenu">
                          <a class="link mr-2 dropdown-item dropdown-toggle pointer"
                             title="Opciones de Packing List">
                            <i class="fa-solid fa-file-invoice"></i> Packing List
                          </a>
                          <div class="dropdown-menu">
                            <a (click)="(pedido.estado === Constantes.ESTADO_PEDIDO_SERVIDO || pedido.estado === Constantes.ESTADO_PEDIDO_SERVIDO_PARCIALMENTE ) ? descargaAlbaranClick(pedido.id!) : null"
                               class="link mr-2 dropdown-item pointer"
                               placement="top"
                               title="Abrir PDF del Packing List"
                               [ngClass]="{'disabled':( pedido.estado !==  Constantes.ESTADO_PEDIDO_SERVIDO && pedido.estado !== Constantes.ESTADO_PEDIDO_SERVIDO_PARCIALMENTE) }">
                              <i class="fa-solid fa-file-pdf"></i> Abrir Packing List
                            </a>

                            <a (click)="( (pedido.estado === Constantes.ESTADO_PEDIDO_SERVIDO || pedido.estado === Constantes.ESTADO_PEDIDO_SERVIDO_PARCIALMENTE) && pedido.cliAlbaranEnXls === '1' )  ? descargaAlbaranXls(pedido.id!) : null"
                               class="link mr-2 dropdown-item pointer"
                               placement="top"
                               title="Descargar Packing List en formato EXCEL"
                               [ngClass]="{'disabled':!( (pedido.estado === Constantes.ESTADO_PEDIDO_SERVIDO || pedido.estado === Constantes.ESTADO_PEDIDO_SERVIDO_PARCIALMENTE) && pedido.cliAlbaranEnXls === '1' ) }">
                              <i class="fa-solid fa-file-excel"></i> Descargar Packing List XLS
                            </a>

                            <a (click)="(pedido.estado === Constantes.ESTADO_PEDIDO_SERVIDO || pedido.estado === Constantes.ESTADO_PEDIDO_SERVIDO_PARCIALMENTE) ? generaPdfEnvio(pedido) : null"
                               class="link mr-2 dropdown-item pointer"
                               placement="top"
                               title="Generar nuevo PAKING LIST para este pedido"
                               [ngClass]="{'disabled':( pedido.estado !== Constantes.ESTADO_PEDIDO_SERVIDO  && pedido.estado !== Constantes.ESTADO_PEDIDO_SERVIDO_PARCIALMENTE) }">
                              <i class="fa-solid fa-file-circle-plus"></i> Generar nuevo Packing List
                            </a>

                          </div>
                        </div>


                        <!-- Opciones de Pedido -->
                        <div class="dropdown-submenu">
                          <a class="link mr-2 dropdown-item dropdown-toggle pointer"
                             title="Opciones de Pedido">
                            <i class="fa-solid fa-receipt"></i> Pedido
                            <span *ngIf="pedido.fac_pack_estado==='2'"
                                  class="badge rounded-circle bg-success ms-2"
                                  style="width: 10px; height: 10px; padding: 5;">&nbsp;</span>
                          </a>
                          <div class="dropdown-menu">

                            <a (click)="(pedido.estado === Constantes.ESTADO_PEDIDO_SERVIDO || pedido.estado === Constantes.ESTADO_PEDIDO_SERVIDO_PARCIALMENTE ) ? openTracking(pedido.id!) : null"
                               class="link mr-2 dropdown-item"
                               title="TRACKING del pedido"
                               [ngClass]="{'disabled':( pedido.estado !== Constantes.ESTADO_PEDIDO_SERVIDO && pedido.estado !== Constantes.ESTADO_PEDIDO_SERVIDO_PARCIALMENTE) }">
                              <i class="fa-solid fa-location-dot"></i> Tracking del pedido
                            </a>

                            <a (click)="abrirModalCabeza(pedido,i)"
                               class="link mr-2 dropdown-item pointer"
                               data-toggle="tooltip"
                               title="Modificar la CABECERA del pedido">
                              <i class="fa-solid fa-pen-to-square"></i> Cabecera del pedido
                            </a>

                            <a (click)="abrirModalFacturacion(pedido,i)"
                               class="link mr-2 dropdown-item pointer"
                               placement="top"
                               title="Cantidad de PACKAGING utilizado">
                              <i class="fa-solid fa-pen-to-square"></i> Packaging del pedido
                              <span *ngIf="pedido.fac_pack_estado==='2'"
                                    class="badge rounded-circle bg-success ms-2"
                                    style="width: 10px; height: 10px; padding: 5;">&nbsp;</span>
                            </a>


                            <a (click)="crearComplementario(pedido,i)"
                               class="link mr-2 dropdown-item pointer"
                               placement="top"
                               title="Crear un pedido COMPLEMENTARIO con el resto de artículos"
                               [ngClass]="{'disabled':( pedido.estado !== '5' ) }">
                              <i class="fa-solid fa-circle-plus"></i> Crear complementario

                              <span *ngIf="pedido.i_complemetarios"
                                    class="badge rounded-circle bg-success ms-2"
                                    style="width: 10px; height: 10px; padding: 5;">&nbsp;</span>
                            </a>


                            <a (click)="abrirModalOrigenPedido(pedido,i)"
                               class="link mr-2 dropdown-item pointer"
                               placement="top"
                               title="Ver los datos del ORIGEN del pedido">
                              <i class="fa-solid fa-info-circle"></i> Origen del pedido
                            </a>


                          </div>
                        </div>


                        <div class="dropdown-divider"></div>

                        <a (click)="accionEspecialPedidoClick(pedido!)"
                           class="link mr-2 dropdown-item"
                           title="Acción ESPECIAL sobre el pedido">
                          <i class="fa-solid fa-gear"></i> Acción especial
                        </a>

                        <a (click)="(pedido.cod_servicio === 'inte') ? pdfEtiquetaPedido(pedido) : null"
                           class="link mr-2 dropdown-item"
                           placement="top"
                           title="Imprmir ETIQUETA de este pedido (Servicio Inte)"
                           [ngClass]="{'disabled': !(pedido.cod_servicio === 'inte')}">
                          <i class="fa-solid fa-print"></i> Imprimir etiqueta Inte
                        </a>

                        <a (click)="(pedido.estado === Constantes.ESTADO_PEDIDO_SERVIDO || pedido.estado === Constantes.ESTADO_PEDIDO_SERVIDO_PARCIALMENTE) ? labelCajas(pedido) : null"
                           class="link mr-2 dropdown-item"
                           placement="top"
                           title="Imprimir etiquetas con el contenido de las cajas de este pedido"
                           [ngClass]="{'disabled':( pedido.estado !== Constantes.ESTADO_PEDIDO_SERVIDO  && pedido.estado !== Constantes.ESTADO_PEDIDO_SERVIDO_PARCIALMENTE) }">
                          <i class="fa-solid fa-boxes-stacked"></i> Imprimir contenido de cajas
                        </a>

                        <a (click)="(pedido.estado === Constantes.ESTADO_PEDIDO_SERVIDO || pedido.estado === Constantes.ESTADO_PEDIDO_SERVIDO_PARCIALMENTE) ? generaXlsEnvio(pedido) : null"
                           class="link mr-2 dropdown-item"
                           placement="top"
                           title="Exportar este pedido a DTX"
                           [ngClass]="{'disabled':( pedido.estado !== Constantes.ESTADO_PEDIDO_SERVIDO  && pedido.estado !== Constantes.ESTADO_PEDIDO_SERVIDO_PARCIALMENTE) }">
                          <i class="fa-solid fa-file-excel"></i> Exportar a DTX
                        </a>

                        <a (click)='abrirModalAvisos(pedido)'
                           class="link mr-2 dropdown-item"
                           placement="top"
                           title="Ver NOTIFICACIONES del cliente sobre este pedido"
                           [ngClass]="{'disabled':( pedido.tot_avisos == 0)}">
                          <i class="fa-solid fa-envelope"></i> Ver notificaciones del cliente
                          <span *ngIf=" pedido.tot_avisos! >0"
                                class="badge rounded-circle bg-success ms-2"
                                style="width: 10px; height: 10px; padding: 5;">&nbsp;</span>
                        </a>

                      </div>
                    </td>

                  </tr>
                </ng-container>
              </tbody>

              <tfoot>
                <tr>
                  <td>Total: </td>
                  <td style="text-align: right; padding-left: 10px">
                    <div class="pl-25 mr-20 monospace">
                      {{ pedidosList.length| number: '0.0-0':'es' }}
                    </div>
                  </td>
                  <td colspan="3"></td>
                  <td style="text-align: right; padding-left: 10px">
                    <div class="pl-25 mr-20 monospace">
                      {{ sumaTotArticulos | number: '0.0-0':'es' }}
                    </div>
                  </td>
                  <td style="text-align: right; padding-left: 10px">
                    <div class="pl-25 mr-20 monospace">
                      {{ sumaTotReferencias | number: '0.0-0':'es' }}
                    </div>
                  </td>
                  <td colspan="7"></td>
                </tr>
              </tfoot>

            </table>
          </div>



        </div>
      </div>

      <div class="clearfix"></div>
    </div>

  </div>




  <!-- Tabla de detalle del pedido -->
  <div id="detallesPedido"
       *ngIf="pedidoDetall.pedido_cli"
       class="col-12">
    <app-pedido-detall [pedidoDetall]="pedidoDetall"
                       [eanSeleccionado]="eanSeleccionado"></app-pedido-detall>
  </div>




</div>


<!-- Modal para facturación de pedidos -->
<app-modal-fact-salida></app-modal-fact-salida>


<!-- Modal para edición de la cabecera del pedido -->
<app-modal-pedido-cabecera></app-modal-pedido-cabecera>


<!-- Modal para avisos del pedido -->
<app-modal-pedido-avisos></app-modal-pedido-avisos>


<!-- Modal para origen del pedido -->
<app-modal-pedido-origen></app-modal-pedido-origen>